import styled from 'styled-components'

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`
